const COLORS = {
  NAVY_BLUE: '#326BA8',
  DARK_BLUE: '#100325',
  MEDIUM_BLUE: '#012840',
  LIGHT_BLUE: '#547180',
  MAIN_WHITE: '#FAF3E5',
  HOT_PINK: '#E52054',
  MAGENTA: '#b71943',
  BLACK: '#000',
  WHITE: '#FFF',
  DISABLED_PINK: '#F9D2DC',
  DISABLED_DARK_GREY: '#999AA8',
  // Duplicated by PURPLE: '#ad4fc9',
  // PURPLE: '#8b56c4',
  SALMON: '#ff8c69',
  WHITE_GREY: '#fbfbfd',
  GREY: '#5f5f5f',
  WARNING: '#fff478',
  SUCCESS: '#379470',
  MEDIUM_GREY: '#9c9c9c',
  PURPLE: '#ad4fc9',
  GREEN: '#15c286',
  YELLOW: '#fbbf54',
  RED: '#ec0f47',
  DARKER_RED: '#a02c5d',
  ORANGE: '#ee6b3b',
  CYAN: '#2ecac9',
  LIGHT_GREY: '#e5e6eb',
  HIGHLIGHT: '#fff2f0',
  DARK_CYAN: '#247191',
  LIGHT_SALMON: '#ffbbb0',
  BLUE_GREY: '#879BA6',
  LIGHT_GREEN: '#a5d6a7',
  DARK_GREY: '#212121',
} as const;

Object.freeze(COLORS);

export default COLORS;
